import { Editor, Node, Path, Text } from 'slate';

const deserializeHtmlToSlate = (
  html,
  startTime,
  endTime,
  manualStartTime,
  speakerName,
  type,
  comments,
  tags,
  highlight,
) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const text = doc.body.textContent?.replace(/^\n+|\n+$/g, '') || '';
  const words = text.trim().split(' ');

  const children = words.map((word, index) => ({
    text: index === words.length - 1 ? word : word + ' ',
    tags: tags,
    highlight: highlight,
    bold: false,
    italic: false,
    underlined: false,
    data: { start: startTime + index * 0.001, end: endTime, manualStart: manualStartTime },
    comments: comments,
  }));

  return [
    {
      type: type,
      id: crypto.randomUUID(),
      speaker: speakerName,
      completed: false,
      children,
    },
  ];
};

const deserializePlainTextToSlate = (
  text,
  startTime,
  endTime,
  manualStartTime,
  speakerName,
  type,
  comments,
  tags,
  highlight,
) => {
  const words = text.trim().split(' ');

  const children = words.map((word, index) => ({
    text: index === words.length - 1 ? word : word + ' ',
    tags: tags,
    highlight: highlight,
    bold: false,
    italic: false,
    underlined: false,
    data: { start: startTime + index * 0.001, end: endTime, manualStart: manualStartTime },
    comments: comments,
  }));

  return [
    {
      type: type,
      id: crypto.randomUUID(),
      speaker: speakerName,
      completed: false,
      children,
    },
  ];
};

export const handleSlatePaste = (editor, html, plain) => {
  // Get current point in the editor
  const { selection } = editor;
  let startTime = 0;
  let endTime = 0;
  let manualStartTime;
  let speakerName = null;
  let type = 'paragraph';
  let comments = null;
  let tags = [];
  let highlight = [];

  if (selection) {
    // Try to find the last inserted text node
    const [nodeEntry] = Editor.nodes(editor, {
      at: selection.anchor,
      match: (n) => Text.isText(n) && !!n.data,
      mode: 'lowest',
    });

    if (nodeEntry) {
      const [node, nodePath] = nodeEntry;
      startTime = node.data.start;
      endTime = node.data.end;
      manualStartTime = node.data.manualStart;
      const parentPath = Path.parent(nodePath);
      const parentNode = Node.get(editor, parentPath);
      speakerName = parentNode.speaker || null;
      type = parentNode.type;
      comments = node.comments ?? null;
      tags = node.tags ?? null;
      highlight = node.highlight ?? null;
    }
  }

  const nodes = html
    ? deserializeHtmlToSlate(html, startTime, endTime, manualStartTime, speakerName, type, comments, tags, highlight)
    : deserializePlainTextToSlate(
        plain,
        startTime,
        endTime,
        manualStartTime,
        speakerName,
        type,
        comments,
        tags,
        highlight,
      );

  return nodes;
};
